/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { deleteHandler, getHandler, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import {
    Blank,
    CreateStorageLocationRequest,
    CreateTechwiseOfficeRequest,
    Effect,
    Setter,
    TechwiseOfficeDetailed,
} from "../../utils/Interfaces";
import { AxiosResponse } from "axios";

export function modifyTechwiseOffice(
    officeId: number,
    payload: CreateTechwiseOfficeRequest,
    dispatch: Dispatch<AnyAction>,
    onRefreshTechwiseOffices: Effect
) {
    postHandler<CreateTechwiseOfficeRequest, Blank>(
        `/api/locations/offices/update/${officeId}`,
        payload,
        dispatch,
        () => {
            onRefreshTechwiseOffices();
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function deleteTechwiseOffice(id: number, dispatch: Dispatch<AnyAction>, onTechwiseOfficeDeleted: Effect) {
    deleteHandler(
        `/api/locations/offices/delete/${id}`,
        dispatch,
        () => {
            onTechwiseOfficeDeleted();
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function techwiseOfficeDetails(
    officeId: number,
    dispatch: Dispatch<AnyAction>,
    setTechwiseOfficeDetails: Setter<TechwiseOfficeDetailed>
) {
    getHandler(
        `/api/locations/offices/details/${officeId}`,
        dispatch,
        (response: AxiosResponse) => {
            setTechwiseOfficeDetails(response.data);
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function addStorageLocation(
    officeId: number,
    payload: CreateStorageLocationRequest,
    dispatch: Dispatch<AnyAction>,
    onStorageLocationCreated: Effect
) {
    postHandler<CreateStorageLocationRequest, Blank>(
        `/api/locations/storage-locations/create/${officeId}`,
        payload,
        dispatch,
        () => {
            onStorageLocationCreated();
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function modifyStorageLocation(
    storageLocationId: number,
    payload: CreateStorageLocationRequest,
    dispatch: Dispatch<AnyAction>,
    onStorageLocationModified: Effect
) {
    postHandler<CreateStorageLocationRequest, Blank>(
        `/api/locations/storage-locations/update/${storageLocationId}`,
        payload,
        dispatch,
        () => {
            onStorageLocationModified();
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function deleteStorageLocation(
    storageLocationId: number,
    dispatch: Dispatch<AnyAction>,
    onStorageLocationDeleted: Effect
) {
    deleteHandler<Blank>(
        `/api/locations/storage-locations/delete/${storageLocationId}`,
        dispatch,
        () => {
            onStorageLocationDeleted();
        },
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}
